module.exports = __webpack_public_path__ + "static/scale-model-of-liberty-bell-museum-in-allentown-pennsylvania-1ab06ea5ca3a3e29c24c778d9b196bfc.png";